import { render, staticRenderFns } from "./RewardsConfettiSVG.vue?vue&type=template&id=19c82bf7&scoped=true"
import script from "./RewardsConfettiSVG.vue?vue&type=script&lang=js"
export * from "./RewardsConfettiSVG.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c82bf7",
  null
  
)

export default component.exports